import { FormControl as MaterialFormControl } from '@mui/material'

const FormControl = MaterialFormControl

export { FormControl }
